import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  GetAllExitPointsAction,
  AddExitPointsAction,
  UpdatedExitPointsAction,
  DeleteExitPointsAction,
} from './exit-points.actions';
import { IPuntosSalida } from '../../core/interfaces/exit-points.interface';
import { HttpService } from '../../core/services/http/http.service';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { GetAllCitiesAction } from '../cities/cities.actions';

export interface ExitPointsStateModel {
  exitPoints: IPuntosSalida[];
}

@State<ExitPointsStateModel>({
  name: 'exitPoints',
  defaults: {
    exitPoints: [],
  },
})
@Injectable()
export class ExitPointsState {
  @Selector() static GetAllData(state: ExitPointsStateModel): IPuntosSalida[] {
    return state?.exitPoints ? state?.exitPoints : [];
  }

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) {}

  @Action(GetAllExitPointsAction)
  async GetAllExitPointsAction(ctx: StateContext<ExitPointsStateModel>) {
    try {
      const resp = await this.httpService.getExitPoints();
      if (resp && resp.length) {
        ctx.patchState({
          exitPoints: resp,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  @Action(AddExitPointsAction)
  async AddExitPointsAction(
    ctx: StateContext<ExitPointsStateModel>,
    { payload }: AddExitPointsAction
  ) {
    return this.httpService
      .postExitPoint(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'El punto de salida se ha creado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllExitPointsAction());
      })
      .catch(err => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(UpdatedExitPointsAction)
  async UpdatedExitPointsAction(
    ctx: StateContext<ExitPointsState>,
    { payload }: UpdatedExitPointsAction
  ) {
    return this.httpService
      .updateExitPoint(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'EL punto de dalida se ha actualizado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllExitPointsAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(DeleteExitPointsAction)
  async DeleteExitPointsAction(
    ctx: StateContext<ExitPointsState>,
    { payload }: DeleteExitPointsAction
  ) {
    return this.httpService
      .deleteExitPoint(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'El punto de salida se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCitiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
